import React, { useState } from 'react';
import { Table, TableProps } from '@otp/ui';
import { getTableConfig } from './config';
import { useTranslation } from 'react-i18next';
import { WttpQuestionAction } from 'src/components/wttp/questions/list/table/columns/actions/actions-modals';
import { PermissionListItem } from 'src/components/permissions/list/types';

type PermissionsTableProps = Omit<TableProps, 'columns'> & {
  className?: string;
  data: Array<PermissionListItem>;
  onActionFinished?: (action: WttpQuestionAction) => void;
  disabledFields?: Array<string>;
};

export const PermissionsTable = ({
  data,
  className,
  options,
  onActionFinished,
  disabledFields,
  ...props
}: PermissionsTableProps) => {
  const pageSize = options.rowsPerPage || 5;
  const { t } = useTranslation();

  const [page, setPage] = useState(0);

  const actualData = data.slice(
    page * pageSize,
    (page + 1) * pageSize,
  ) as PermissionListItem[];

  const tableConfig = getTableConfig(actualData, {
    t,
    onActionFinished,
    disabledFields,
  });

  const onChangePage = (currentPage: number) => {
    setPage(currentPage);
  };

  return (
    <div className={className}>
      <Table
        options={{ onChangePage, rowsPerPage: pageSize, ...options }}
        {...props}
        data={actualData}
        columns={tableConfig}
      />
    </div>
  );
};
